import { registerListener } from "../../../html/register-listener";
import { defer } from '../../../control-flow/defer';

// How much to clear the bottom and right edge of the window
const CLEARANCE = 48; // CSS pixels

// How much to clear the parent element
const MARGIN = 12; // CSS pixels

/**
 * This implements a floating menu panel that is absolutely positioned under
 * a button.
 */
export class WalkInPanel extends HTMLElement {

    constructor() {
        super();
        this.style.display = 'none';
    }

    show(under: HTMLElement) {
        const
            ref = under.getBoundingClientRect(),
            viewportWidth = document.documentElement.clientWidth,
            viewportHeight = document.documentElement.clientHeight,
            maxWidth = viewportWidth - ref.x - CLEARANCE,
            maxHeight = viewportHeight - ref.y - CLEARANCE;

        this.style.position = 'fixed';
        this.style.left = `${ref.left}px`;
        this.style.top = `${ref.bottom + MARGIN}px`;
        this.style.maxWidth = `${maxWidth}px`;
        this.style.maxHeight = `${maxHeight}px`;
        this.style.display = '';

        // We defer this registration until we're done processing the current
        // click that showed this panel. Otherwise we would register a handler
        // that would then dutifully handle the click that showed this item.
        defer(() => {
            registerListener(window, 'click', this.closeIfOutside);
        });
    }

    hide() {
        this.style.display = 'none';
        removeEventListener('click', this.closeIfOutside);
    }

    toggle = (under: HTMLElement) => {
        if(this.visible) {
            this.hide();
        } else {
            this.show(under);
        }
    }

    get visible(): boolean {
        return this.style.display != 'none';
    }

    closeIfOutside = (event: MouseEvent) => {
        if(event) {
            const path = event.composedPath();
            if(path.includes(this)) {
                return;
            }
        }
        this.hide();
    }
}
export default WalkInPanel;
window.customElements.define('walk-in-panel', WalkInPanel);
